import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { baseURL, headers } from "../../../../../global/api";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { DeletePaymentApi, individualPDF } from "./PaymentReceivingAction";
import { changeDateFormate, PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from "material-table";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


const ViewPaymentReceiving = (props) => {
  const tableRef = useRef();
  // function updateTableQuery() {
  //   tableRef.current.onQueryChange()
  // };

  useEffect(() => {
    props.setHeading("Payment Receiving List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialTable
          tableRef={tableRef}
          title="Payment Receiving List"
          columns={[
            { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
            { title: "Area", field: "areaId.areaName", editable: 'never' },
            { title: "Shop", field: "shopId.shopName", editable: 'never' },
            { title: "DSF", field: "bookerId.userName", editable: 'never' },
            { title: "Date", field: 'date', render: (rowData) => changeDateFormate(rowData.date), editable: 'never' },
            { title: "Payment", field: "payment", editable: 'never' },
            { title: "Discount", field: "discount", editable: 'never' },
            { title: "Received By", field: "receivedBy", editable: 'never' },
            { title: "Discount Reason", field: "discountReason", editable: 'never' },
            { title: 'Created By', field: 'userDetails.userName', editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/booking/cash_receive_list?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, {
                method: "POST",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "l";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Payment Receiving Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((elt) => [
                elt.sequenceNumber,
                elt.areaId.areaName,
                elt.shopId.shopName,
                elt.bookerId.userName,
                changeDateFormate(elt.date),
                elt.payment,
                elt.receivedBy,
                // elt.discount,
                // elt.discountReason,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Payment Receiving Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.DeletePaymentApi(oldData._id);
                }, 600);
              }),
          }}
          actions={[
            (rowData) => ({
              icon: () => <LocalPrintshopIcon />,
              tooltip: "Print Payment Receiving",
              onClick: (event, rowData) => {
                props.individualPDF(rowData);
              },
            }),
          ]}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    setHeading: (data) => dispatch(setHeading(data)),
    DeletePaymentApi: (id) => dispatch(DeletePaymentApi(id)),
    individualPDF: (data) => dispatch(individualPDF(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewPaymentReceiving);
